var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDarkMode = function SvgDarkMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "#F2F4F6",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1982 21.2806C26.0606 21.0555 25.6736 20.7053 24.7105 20.8721C24.1773 20.9638 23.6356 21.0055 23.0938 20.9805C21.0902 20.8971 19.2757 20.005 18.0116 18.6292C16.8937 17.4203 16.2057 15.8444 16.1971 14.1435C16.1971 13.193 16.3863 12.2759 16.7733 11.4087C17.1517 10.5666 16.8851 10.1247 16.6959 9.94129C16.4981 9.74952 16.0337 9.48271 15.1222 9.84957C11.6051 11.2837 9.42944 14.7022 9.68742 18.3624C9.94541 21.8059 12.4392 24.7492 15.7414 25.8581C16.5325 26.1249 17.3666 26.2833 18.2266 26.3166C18.3642 26.325 18.5018 26.3333 18.6394 26.3333C21.5201 26.3333 24.2203 25.016 25.923 22.7731C26.4992 21.9977 26.3444 21.5058 26.1982 21.2806Z",
    fill: "#6A737D"
  })));
};
export default SvgDarkMode;